import { defineSlotRecipe } from '@chakra-ui/react';

export const searchLocationSlotRecipe = defineSlotRecipe({
    slots: ['icon'],
    base: {
        icon: {
            color: 'secondary.500',
            pointerEvents: 'none',
            height: '100%',
        },
    },
});
